import * as Analytics from 'analytics/analytics'
import useLoyaltyOfferPageTargetRoomUpgrade from 'components/OfferPage/hooks/useLoyaltyOfferPageTargetRoomUpgrade'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import Switch from 'LuxKit/Switch/Switch'
import BodyText from 'LuxKit/Typography/BodyText'
import React, { useCallback } from 'react'

interface Props {
  package: App.Package;
}

function OfferPageLoyaltyStayUpgradeCallOutBannerSwitch({
  package: pkg,
}: Props) {
  const {
    selectedTargetUpgradePackage,
    toggleTargetRoomUpgrade,
  } = useLoyaltyOfferPageTargetRoomUpgrade(pkg)

  const handleToggleTargetRoomUpgrade = useCallback(() => {
    toggleTargetRoomUpgrade(!selectedTargetUpgradePackage)
    Analytics.trackClientEvent({
      subject: 'loyalty_room_upgrade',
      action: selectedTargetUpgradePackage ? 'toggled_off' : 'toggled_on',
      category: 'offer_page',
      type: 'interaction',
    })
  }, [selectedTargetUpgradePackage, toggleTargetRoomUpgrade])

  return <Group direction="horizontal" verticalAlign="center" gap={8} as="label">
    <CSSBreakpoint min="desktop">
      {!selectedTargetUpgradePackage && <BodyText variant="medium" wrap="no-wrap">Apply upgrade</BodyText>}
      {!!selectedTargetUpgradePackage && <BodyText variant="medium" wrap="no-wrap">Upgrade applied</BodyText>}
    </CSSBreakpoint>
    <Switch checked={!!selectedTargetUpgradePackage} onChange={handleToggleTargetRoomUpgrade} />
  </Group>
}

export default OfferPageLoyaltyStayUpgradeCallOutBannerSwitch
